import { Component, Input, OnInit } from '@angular/core';
import { ClosedMerchantCount } from '../../../../shared/models/EvoSalesPortalModel';
import { DashboardService } from '../../../../shared/services/dashboard.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BindingContext } from '../../../../shared/models/BindingContext';
import { DashboardWidget } from '../../dashboard-interface';

@Component({
    selector: 'app-dashboard-boarded',
    templateUrl: './dashboard-boarded.component.html',
    styleUrls: ['./dashboard-boarded.component.scss'],
    host: { 'class': 'col-md-6 col-lg-4' }
})
export class DashboardBoardedComponent extends DashboardWidget {
    private debug: boolean = false;
    @Input() merchantCountsContext: BindingContext = new BindingContext();
    @Input() title: string = "";
}
